import "./OurJourney.module.css";
import ClassroomHeader from "@/reusable_sections/Header";
import TheBigPicture from "./sections/TheBigPicture";
import ProjectShowcase from "./sections/ProjectShowcase";
import ClassroomFooter from "@/reusable_sections/Footer";
export default function OurJourneyPage() {
  return <div>
      <ClassroomHeader />
      <TheBigPicture />
      <ProjectShowcase />
      <ClassroomFooter />
    </div>;
}